import React, { useState } from 'react';
import { Button, Container, Card, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import validator from 'validator';
import { UserLogin } from '../Auth/Api';
import { useAuth } from '../Auth/AuthContext';

const REMEMBER_EMAIL_KEY = 'voicegps_remember_email';

const Login = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    const [Data, setData] = useState({
        Email: localStorage.getItem(REMEMBER_EMAIL_KEY) || '',
        Password: '',
        Remember: !!localStorage.getItem(REMEMBER_EMAIL_KEY),
    });

    const inputData = (e) => {
        setData({ ...Data, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!Data.Email) return toast.error('Email Id Field Is Required');
        if (!validator.isEmail(Data.Email)) return toast.error('Enter Your Valid Email Id');
        if (!Data.Password) return toast.error('Password Field Is Required');

        if (Data.Remember) {
            localStorage.setItem(REMEMBER_EMAIL_KEY, Data.Email);
        } else {
            localStorage.removeItem(REMEMBER_EMAIL_KEY);
        }

        const Result = await UserLogin(Data);
        if (Result.data?.Status === true) {
            toast.success(Result.data.Response_Message);
            login(Result.data.token, Result.data.Data);
            navigate('/Home');
        } else {
            toast.error(Result.data?.Response_Message || 'Login failed');
        }
    };

    return (
        <Container>
            <div className="auth">
                <div className="auth-box">
                    <Card>
                        <Card.Header className="pb-0">
                            <div className='auth-logo'>
                                <img src="../../logo/appicon.jpg" className='logo-mini' alt="GPS Area Measurements" />
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleLogin}>
                                <h1 className='auth-title'>Sign in</h1>
                                <h2 className='auth-subtitle'>GPS Area Measurements</h2>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        className="my-2"
                                        name="Email"
                                        placeholder="Enter Your Email"
                                        value={Data.Email}
                                        onChange={inputData}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-4 input-prefix">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type={showPassword ? 'text' : 'password'}
                                        className="my-2"
                                        name="Password"
                                        placeholder="Enter Password"
                                        value={Data.Password}
                                        onChange={inputData}
                                    />
                                    <i
                                        onClick={() => setShowPassword(!showPassword)}
                                        className={`bx ${showPassword ? 'bx-show' : 'bx-hide'}`}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-4" controlId="formRememberMe">
                                    <Form.Check
                                        type="checkbox"
                                        label="Remember Me"
                                        checked={Data.Remember}
                                        onChange={(e) => setData({ ...Data, Remember: e.target.checked })}
                                    />
                                </Form.Group>
                                <Button variant="primary" type="submit" className="w-100">Sign In</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </Container>
    );
};

export default Login;
